import { ActionTree, Commit } from "vuex";
import { Store, StoreContract } from "throne-api";
import types from "@/store/types";

import {
    fetchStoreByStoreName,
    fetchStoreContractByStoreName,
    fetchAreaListByStoreId,
    fetchVacancyAreaListByStoreId,
} from "@/api";

import { RootState } from "./state";

export const actions: ActionTree<RootState, any> = {
    [types.actions.SETUP]: async ({ commit }: { commit: Commit }, storeName: string): Promise<boolean> => {
        const store: Store | null = await fetchStoreByStoreName(storeName);
        if (store === null) {
            return false;
        }
        const storeContract: StoreContract | null = await fetchStoreContractByStoreName(storeName);
        commit(types.mutations.SET_STORE, store);
        commit(types.mutations.SET_STORE_CONTRACT, storeContract);
        commit(types.mutations.SET_AREA_LIST, await fetchAreaListByStoreId(store.storeId));
        commit(types.mutations.SET_VACANCY_AREA_LIST, await fetchVacancyAreaListByStoreId(store.storeId));
        return true;
    },
    [types.actions.LOOP]: async ({ commit, state }: { commit: Commit; state: RootState }): Promise<void> => {
        if (state.store === undefined) {
            throw new Error("Store should be exist");
        }
        const store: Store = state.store;
        setInterval(async () => {
            commit(types.mutations.SET_VACANCY_AREA_LIST, await fetchVacancyAreaListByStoreId(store.storeId));
        }, 3 * 1000);
        setInterval(async () => {
            commit(types.mutations.SET_AREA_LIST, await fetchAreaListByStoreId(store.storeId));
        }, 60 * 60 * 1000);
    },
};
